import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BroadcasterService } from 'ng-broadcaster';
import { BehaviorSubject, Subject } from 'rxjs';

import { CommonNotificationsService } from '../../services/commonnotifications/common-notifications.service';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false,
})
export class NotificationsComponent implements OnInit {
    createdRequestDate: any;
    source: string;
    unSubscribe = new Subject<void>();

    notificationsState: BehaviorSubject<{
        eventTypesList: {
            id: string;
            displayName: string;
        }[];
    }> = new BehaviorSubject(undefined);
    isFromRequestLogs: boolean;
    openProcessLogs: () => void;

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<NotificationsComponent>,
        private _notification: CommonNotificationsService,
        private _broadcaster: BroadcasterService,
        private _libUtils: UtilsService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    loadEventsDetails = eventTypes => {
        if (!this.data.isFromRequestLogs) {
            this.data.createdRequestDate.includes('T')
                ? this._libUtils.transformDateToLocale(this.data.createdRequestDate, 'YYYY-MM-DDTHH:MM:SSZ', 'ddMMMyyyy HH:MM:SS AM', false)
                : this.data.createdRequestDate;
        }
        this.notificationsState.next({
            eventTypesList: eventTypes.filter(eventType => ['mapro', 'transformation', 'integration'].includes(eventType.service)),
        });
    };

    closeModal = () => {
        this.dialogRef.close();
    };

    ngOnInit() {
        this._notification.getEventTypes(false, this.loadEventsDetails, () => {}, 'ALL');
        this._broadcaster.on('logout').subscribe(() => {
            this.dialog.closeAll();
        });
    }

    // tslint:disable-next-line: use-life-cycle-interface
    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
